import Vue from 'vue';
import Router from 'vue-router';
import WebLayout from '../components/WebLayout.vue';
import MainContent from '../components/MainContent.vue';
import Download from '../components/Download.vue';
import RuleNtpp from '../components/gamesrule/Rule_Ntpp.vue';
import RuleTK2cards from '../components/gamesrule/Rule_TK-2cards.vue';
import RuleTK3cards from '../components/gamesrule/Rule_TK-3cards.vue';
import Rule13cardsPoker from '../components/gamesrule/Rule_13cardsPoker.vue';
import RulePokdeng from '../components/gamesrule/Rule_Pokdeng.vue';
import RulePokdeng2 from '../components/gamesrule/Rule_Pokdeng2.vue';
import Rule11Hilo from '../components/gamesrule/Rule_11Hilo.vue';
import Rule6poker from '../components/gamesrule/Rule_6cardsPoker.vue';
import Rulebrp from '../components/gamesrule/Rule_BRP.vue';
import Rulebrb from '../components/gamesrule/Rule_BRB.vue';
import RulePunpae from '../components/gamesrule/Rule_Panpae.vue';
import RuleKang from '../components/gamesrule/Rule_Kang.vue';
import RuleBingo from '../components/gamesrule/Rule_Bingo.vue';
import RuleFootball from '../components/gamesrule/Rule_Football.vue';
import RuleFruitslot from '../components/gamesrule/Rule_Fruitslot.vue';
import RuleBingo2 from '../components/gamesrule/Rule_Bingo2.vue';
import RuleFishing from '../components/gamesrule/Rule_Fishing.vue';
import RuleHorseRacing from '../components/gamesrule/Rule_HorseRacing.vue';
import RuleDragonTiger from '../components/gamesrule/Rule_DragonTiger.vue';
import RuleBaccarat from '../components/gamesrule/Rule_Baccarat.vue';
import Faq from '../components/Faq.vue';
import Security from '../components/Security.vue';
import TermOfUse from '../components/TermOfUse.vue';
import ContactUs from '../components/ContactUs.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: { name: 'maincontent' },
    },
    {
      name: 'web-layout',
      path: '*',
      component: WebLayout,
      children: [
        {
          name: 'maincontent',
          path: '/home',
          component: MainContent,
          default: true,
        },
        {
          name: 'download',
          path: '/download',
          component: Download,
        },
        {
          name: 'rule_ntpp',
          path: '/rule/ntpp',
          component: RuleNtpp,
        },
        {
          name: 'rule_bingo2',
          path: '/rule/bingo2',
          component: RuleBingo2,
        },
        {
          name: 'rule_fruitslot',
          path: '/rule/fruitslot',
          component: RuleFruitslot,
        },
        {
          name: 'rule_tk_2cards',
          path: '/rule/tk_2cards',
          component: RuleTK2cards,
        },
        {
          name: 'rule_tk_3cards',
          path: '/rule/tk_3cards',
          component: RuleTK3cards,
        },
        {
          name: 'rule_13poker',
          path: '/rule/13cardspoker',
          component: Rule13cardsPoker,
        },
        {
          name: 'rule_pokdeng',
          path: '/rule/pokdeng',
          component: RulePokdeng,
        },
        {
          name: 'rule_pokdeng2',
          path: '/rule/pokdeng2',
          component: RulePokdeng2,
        },
        {
          name: 'rule_11hilo',
          path: '/rule/11hilo',
          component: Rule11Hilo,
        },
        {
          name: 'rule_brp',
          path: '/rule/brp',
          component: Rulebrp,
        },
        {
          name: 'rule_brb',
          path: '/rule/brb',
          component: Rulebrb,
        },
        {
          name: 'rule_6poker',
          path: '/rule/6cardspoker',
          component: Rule6poker,
        },
        {
          name: 'rule_punpae',
          path: '/rule/punpae',
          component: RulePunpae,
        },
        {
          name: 'rule_paikang',
          path: '/rule/paikang',
          component: RuleKang,
        },
        {
          name: 'rule_bingo',
          path: '/rule/bingo',
          component: RuleBingo,
        },
        {
          name: 'rule_football',
          path: '/rule/football',
          component: RuleFootball,
        },
        {
          name: 'rule_fishing',
          path: '/rule/fishing',
          component: RuleFishing,
        },
        {
          name: 'rule_horseracing',
          path: '/rule/horseracing',
          component: RuleHorseRacing,
        },
        {
          name: 'rule_dragontiger',
          path: '/rule/dragontiger',
          component: RuleDragonTiger,
        },
        {
          name: 'rule_baccarat',
          path: '/rule/baccarat',
          component: RuleBaccarat,
        },
        {
          name: 'faq',
          path: '/faq',
          component: Faq,
        },
        {
          name: 'security',
          path: '/security',
          component: Security,
        },
        {
          name: 'termofuse',
          path: '/termofuse',
          component: TermOfUse,
        },
        {
          name: 'contactus',
          path: '/contactus',
          component: ContactUs,
        },
      ],
    },
  ],
});

export default router;
